<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.cdn }}</div>
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="alert alert-danger" v-show="result.value === 'failed'">
          {{ i18n.results.cdn }} {{ cdnCheckUrl }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global Image */
import CheckerStatus from './CheckerStatus'

const checkerName = 'cdn-access'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  computed: {
    cdnCheckUrl () {
      return window.SYSTEM_CHECK.cdnCheckUrl
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var img = new Image()
    img.onload = () => {
      this.result.value = 'passed'
      this.$emit('completed', {name: checkerName, result: 'passed'})
    }
    img.onerror = () => {
      this.result.value = 'failed'
      this.$emit('completed', {name: checkerName, result: 'failed'})
    }
    img.src = this.cdnCheckUrl + '?_=' + (new Date().getTime())
  }
}
</script>



// WEBPACK FOOTER //
// CdnAccess.vue?9ed5cdde